if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      this.settings = this.getSettingsSource().dataset;
      this.mode = this.settings.mode;
      this.boxesEl = this.querySelector('.timer__boxes');
      this.expiredEl = this.querySelector('.timer__expired-message');
      this.daysEl = this.querySelector('[data-timer-days]');
      this.hoursEl = this.querySelector('[data-timer-hours]');
      this.minutesEl = this.querySelector('[data-timer-minutes]');
      this.secondsEl = this.querySelector('[data-timer-seconds]');

      this.setTarget();
      this.tick();
      this.interval = setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    // With data-sync-from, the deadline comes from the timer with that role
    // (e.g. mobile banner follows the desktop banner), so it's set only once.
    getSettingsSource() {
      const role = this.dataset.syncFrom;
      if (!role) return this;
      return document.querySelector(`countdown-timer[data-timer-role="${role}"]`) || this;
    }

    setTarget() {
      if (this.mode === 'weekly') {
        const [hours, minutes] = (this.settings.weeklyTime || '10:30').split(':').map(Number);
        const targetDay = parseInt(this.settings.weeklyDay, 10) || 0;
        const now = new Date();
        const target = new Date(now);
        target.setHours(hours, minutes, 0, 0);

        let dayDiff = (targetDay - now.getDay() + 7) % 7;
        if (dayDiff === 0 && target <= now) {
          dayDiff = 7;
        }
        target.setDate(now.getDate() + dayDiff);
        this.target = target;
      } else {
        const dateStr = this.settings.date;
        const timeStr = this.settings.time || '23:59';
        this.target = new Date(`${dateStr}T${timeStr}:00`);
      }
    }

    tick() {
      const now = new Date();
      let diff = this.target - now;

      if (diff <= 0) {
        if (this.mode === 'weekly') {
          this.setTarget();
          diff = this.target - now;
        } else {
          if (this.boxesEl) this.boxesEl.hidden = true;
          if (this.expiredEl) this.expiredEl.hidden = false;
          clearInterval(this.interval);
          this.dispatchEvent(new CustomEvent('countdown:expired', { bubbles: true }));
          return;
        }
      }

      const totalSeconds = Math.floor(diff / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      if (this.daysEl) this.daysEl.textContent = String(days).padStart(2, '0');
      if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
      if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
      if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}
